// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FeedbackIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FeedbackIcon" ref={forwardedRef} {...props}>
      <path d="M13.25 9V7.032h-1.888a4.7 4.7 0 0 1 .124 1.5H12V11.5l.01-.006 4.441-2.96H18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H8.5v1.5h9v3.532h-.97z" />
      <path d="M2.5 16.84V14.5h8v2.34h.002v1.66H12V14a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v4.5h1.498v-1.66z" />
      <path d="M10 8a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0M6.5 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const FeedbackIcon = /* @__PURE__ */ Object.assign(
  FeedbackIconComponent,
  { displayName: 'FeedbackIcon' },
);
